import { useQuery } from '@tanstack/react-query';
import { fetchDealerById } from '../services/dealers';
import { dealerKeys } from './useDealersQuery';

export const useDealerQuery = (id: string, opts?: { suppressForbiddenToast?: boolean }) => {
    return useQuery({
        queryKey: dealerKeys.detail(id),
        queryFn: () => fetchDealerById(id, opts),
        enabled: !!id,
    });
};
